<section class="img-container img-fluid mb-5">
  <img class="d-block mx-auto mb-4" src="../../../assets/img/Flygets_priser1.jpg" alt="pricing image"
    class="width-100">

  <div class="py-5 text-center">
    <h2>{{ 'CONTACT.TITLE' | transloco }}</h2>
    <p class="lead">{{ 'CONTACT.TEXT' | transloco }}</p>
    <button class="my-3" mat-raised-button routerLink="/flygets/flygets-start">{{ 'CONTACT.BACK' | transloco | uppercase}}</button>
  </div>

</section>

<div class="container">

  <form [formGroup]="formGroup" (ngSubmit)="onSubmit(formGroup.value)">

    <app-text-input [formControl]='formGroup.controls["firstname"]' [label]="'FORM.FIRST_NAME' | transloco"
      [placeholder]="'PLACEHOLDER.FIRST_NAME' | transloco" [icon]="'account_box'">
    </app-text-input>

    <app-text-input [formControl]='formGroup.controls["lastname"]' [label]="'FORM.LAST_NAME' | transloco"
      [placeholder]="'PLACEHOLDER.LAST_NAME' | transloco" [icon]="'account_box'">
    </app-text-input>

    <app-text-input [formControl]='formGroup.controls["email"]' [type]="'email'" [label]="'Email'"
      [placeholder]="'PLACEHOLDER.EMAIL' | transloco" [icon]="'email'">
    </app-text-input>

    <app-text-input [formControl]='formGroup.controls["phone"]' [type]="'tel'" [label]="'FORM.PHONENUMBER' | transloco"
      [placeholder]="'PLACEHOLDER.PHONENUMBER' | transloco" [icon]="'smartphone'">
    </app-text-input>

    <app-textarea-input [formControl]='formGroup.controls["message"]' [label]="'FORM.COMMENT' | transloco"
      [placeholder]="'PLACEHOLDER.OPTIONAL_INFO' | transloco">
    </app-textarea-input>

    <button [disabled]="formGroup.status === 'INVALID'" mat-raised-button type="submit">Skicka</button>
  </form>

</div>


<div class="jumbotron jumbotron-fluid mt-4">
  <div class="container">
    <h6>Flygets Långtidsparkering</h6>
    <p class="lead">{{ 'CONTACT.VISITINGADDRESS' | transloco }}</p>
    <p class="small">Caravellegatan</p>
    <p class="small">195 61 Rosersberg</p>
    <p class="small">{{ 'CONTACT.PHONE' | transloco }}</p>
    <p class="small">{{ 'CONTACT.MAIL' | transloco }}</p>
  </div>
</div>

<app-small-footer></app-small-footer>
